import { openSelectOptions, selectOption, cr_state } from '@/select-box.js';
import $ from 'jquery';
import PriseConstante from '@/views/consultations/prendre-constante'
import TraiterConduite from '@/views/consultations/modal-traiter-conduite'
import TraiterSoinsSansConsultation from '@/views/consultations/modal-traite-soins-sans-consultation'
import StatDiagnostiques from '@/views/consultations/statistique-diagnostiques'
import ManageConstante from '@/views/consultations/en-cours/constantes/manage-constante'
import ActiviteMedecin from './activite-medecin'
import SallePrelevement from '@/views/tableau-de-bord/salle-prelevement'
import ConsultationsMedecin from './consultations-medecin'
import AvisMedicauxRecus from './avis-medicaux-recus'
import RendezVousMedecin from './rendez-vous-medecin'
import { openMenu, closeMenu, open_menu_state, convertDateToYyyyMmDd } from '@/function/function.js';
import moment from 'moment'
import KineDashboard from '@/components/kine-dashboard.vue'

import store_consultation from "@/store/mods/consultations/consultations";

export default {
    name: 'dashboard-medecin',
    components: {
        KineDashboard,
        PriseConstante, TraiterConduite, ManageConstante, 
        TraiterSoinsSansConsultation, StatDiagnostiques,
        ActiviteMedecin, SallePrelevement, ConsultationsMedecin, AvisMedicauxRecus, RendezVousMedecin
    },
    props: [],
    data() {
        return {
            kine_specialites: { suivies: [], toutes_suivies: false }, kine_cartes: null,
            user_id: 0,
            vm_state: open_menu_state,

            monthConsultationsLoading: false,
            jr_selected: 'Aujourd\'hui',
            mm_selected: 'Mars',
            consult_month_selected: {
                french: null
            },
            selectedConsultation: null,
            curr_state: cr_state,
            date: new Date(),
            monthsLatest: new Array(),

            drp_menu_class: [],

            liste_conduites: [], //  Liste des conduites du jour
            cat_loading: true,
            selectedConduite: null,
            selectedMoment: null,
            soin_selected: {},
            heure_selected: '',

            filter: "",
            tableIsBusy: true,
            perPage: 10,
            currentPage: 1,

            salle_is_loading: true,
            salle_is_empty: false,

            l_month: [
                { nth_month: 1, month: "Janvier" }, { nth_month: 2, month: "Février" },
                { nth_month: 3, month: "Mars" }, { nth_month: 4, month: "Avril" },
                { nth_month: 5, month: "Mai" }, { nth_month: 6, month: "Juin" },
                { nth_month: 7, month: "Juillet" }, { nth_month: 8, month: "Août" },
                { nth_month: 9, month: "Septembre" }, { nth_month: 10, month: "Octobre" },
                { nth_month: 11, month: "Novemebre" }, { nth_month: 12, month: "Décembre" }
            ],
            curr_month: '',
            stat_sante_loading: true,
            stat_sante_empty: false,

            stat_date: '',
            stats_more: false,

            modal_toggler: 0,
            selected_constant: {},
            data_to_be_deleted: {},
            selected_consultation: {},
            info_user: {},
            can_autre_maladie: false,

            consultations_attentes_constantes: [],
            nb_attente_constantes: 0,
            p_curr_page: 1,
            p_per_page: -1,
            p_total_pages: 0,
            p_filter: '',
            p_last_page: 0,
            p_goto_page: 1,
            p_fields: [
                { key: 'patient', label: 'Patient' }, 
                'sexe', 'contact', 'consultation', 
                'constantes', { key: 'actions', label: 'Actions' }
            ],

            // SUITE DE SOINS TABLE
            sut_fields: ['patient', 'sexe', 'contact', 'consultation', { key: 'est_valide', label: 'Validités' }],
            liste_suites_soins: [],
            suite_is_loading: true,
            suite_is_empty: false,
            sut_curr_page: 1,
            sut_per_page: -1,
            sut_total_pages: 0,
            sut_filter: '',
            sut_last_page: 0,
            sut_goto_page: 1,
            search_item: ''
        }
    },

    watch: {
        kine_enabled() {
            this.kine_specialites = { suivies: [], toutes_suivies: false }
            this.kine_cartes = null
        },
        'activeRole.nom'(role, ancien_role) {
            if (ancien_role === 'ROLE_MEDECIN' && role !== 'ROLE_MEDECIN') {
                this.refreshSuiteDeSoins()
                this.refreshSalleAttente()
                this.$store.dispatch('getCountMonthConsultations', { month: this.currentMonth.english })
                this.$store.dispatch('getCountTodayConsultations')
            }
        },
        curr_month() {
            this.getStatSante(1)
        },

        sut_filter() {
            if (this.sut_filter == '') {
                this.search_item = ''
                this.refreshSuiteDeSoins()
            }
        },

        p_filter() {
            if (this.p_filter == '') {
                this.search_item = ''
                this.refreshSalleAttente()
            }
        }
    },

    computed: {
        kine_enabled() { return process.env.VUE_APP_KINE_CLINICAL_ENABLED === 'true' && this.activeRole.nom === 'ROLE_MEDECIN' },
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        monthConsultations() {
            return this.$store.getters['currentMonthConsultationsCount'];
        },

        months() {
            return this.monthsOfYear();
        },

        latestMonthsOfCurrentYear() {
            let index;

            for (index = 0; index < this.date.getMonth() + 1; index++) {
                this.monthsLatest[index] = this.months[index];

            }
            return this.monthsLatest;
        },

        countTodayConsultations() {
            return this.$store.getters['todayConsultationsCount']
        },

        currentMonth() {
            return this.latestMonthsOfCurrentYear[this.date.getMonth()];
        },

        // 
        currentCAT() {
            return this.$store.getters['cat'];
        },

        stats_sante() {
            return this.$store.getters['stats_sante'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale'];
        },
    },
    mounted() {
        this.$store.dispatch('getEvolutionIDInitiale')

        this.user_id = this.userCredentials.id
        this.userInfoSetter()

        this.refreshSuiteDeSoins()

        this.consult_month_selected = this.currentMonth

        this.curr_month = {
            nth_month: this.consult_month_selected.nth_month,
            month: this.consult_month_selected.french
        }
        if (this.activeRole.nom !== 'ROLE_MEDECIN') {
            this.$store.dispatch('getCountMonthConsultations', { month: this.currentMonth.english })
        }

        // statistique sante
        this.getStatSante(1)
        
        setTimeout(() => {
            $('.shw1').fadeIn()
        }, 500);

        setTimeout(() => {
            $('.shw2').fadeIn()
        }, 700);

        setTimeout(() => {
            $('.shw3').fadeIn()
        }, 900);

        setTimeout(() => {
            $('.shw4').fadeIn()
        }, 900);

        // CONSULTATION EN ATTENTE
        this.refreshSalleAttente()
        
        if (this.activeRole.nom !== 'ROLE_MEDECIN') this.$store.dispatch('getCountTodayConsultations')

        let date_cat = convertDateToYyyyMmDd.convertDate(this.date);
        this.$store.dispatch('getCurrCat', { consultation_id: 0, date_cat: date_cat }).then((response) => {
            this.liste_conduites = response
            this.cat_loading = false;
        });

        let t = this;

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("drp-container")) {
                if (t.vm_state != 0) {
                    t.openMenu(t.vm_state, 'drp-menu', 'animate-zoomIn', 'animate-zoomOut')
                }
            }
        });

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("select-box-o")) {
                if (t.curr_state != 0) {
                    t.openSelectOption(t.curr_state, 'slt-month')
                }
            }
        });

        this.$store.commit("SET_SELECTED_CONSULTATION_ENCOURS", {});
        this.$store.commit("SET_CONSULTATIONS_EN_ATTENTE", []);
    },

    methods: {
        recevoir_specialites_kine(specialites) {
            this.kine_specialites = specialites || { suivies: [], toutes_suivies: false }
        },
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.userCredentials.name,
                titre: this.userCredentials.titre
            }
        },

        goToConsultation(item) {
            console.log('item', item)
            const data = {
                patient_id: item.patient_id,
                tarif_consultation_id: item.tarif_consultation_id,
                is_mobile_user: item.patient_has_mobile_user,
            }
            this.$store.commit("SET_SELECTED_CONSULTATION_ENCOURS", data);
            this.$router.push({ path: 'patients/'+data.patient_id+'/consulter' })
        },

        getStatSante(type_filtre) {
            if (this.activeRole.nom === 'ROLE_MEDECIN') return
            this.stat_sante_loading = true
            var filter_stat = {}
            
            if (type_filtre == 1) { // FIltre par mois
                filter_stat = {
                    type_filtre: 1,
                    date: this.curr_month.nth_month
                }
            } else {
                filter_stat = {
                    type_filtre: 2,
                    date: this.stat_date
                }
            }
            
            this.$store.dispatch('getStatistiqueSante', filter_stat).then(() => {
                if (this.stats_sante.length > 0) {
                    this.stat_sante_empty = false

                    if (this.stats_sante.length > 3) {
                        this.stats_more = true
                    }
                } else {
                    this.stat_sante_empty = true
                }

                this.stat_sante_loading = false
            })
        },

        properJson(data){
            try {
               return JSON.parse(data)
            } catch(e){
                return data

            }
        },
        
        formatHour: function(date){
            let formattedDate = moment(date)

            return formattedDate.format('HH:mm');
        },

        customDateFormat(given_date) {
            if (!given_date)
                given_date = new Date()

            let only_date = "",
                only_hour = "";
            let date = new Date(given_date);
            let month = date.getMonth() + 1;
            only_date = date.getDate() + "/" + month + "/" + date.getFullYear();
            let c_hour = date.getHours();
            let c_minute = date.getMinutes();
            if (c_hour < 10) c_hour = "0" + c_hour;
            if (c_minute < 10) c_minute = "0" + c_minute;
            only_hour = c_hour + ":" + c_minute;

            return {
                date: only_date,
                hour: only_hour
            }
        },

        intakeConstant(consultation) {
            this.modal_toggler = (this.modal_toggler === 0)?1:0
            this.selected_consultation = {
                id: consultation.id,
                sexe: (consultation.patient.sexe_id == 2)?'F':'M',
                tarif_consultation: {
                    type_consultation_id: consultation.tarif_consultation.type_consultation.id
                }
            }
            this.selected_constant = {
                constante_group_id: 0
            }

            $('.cste-mdl'+this.evolution_id_initiale).modal('show')
        },

        /**
         * Rafraichir la salle d'attente
         * @returns 
         */
        refreshSalleAttente() {
            if (this.activeRole.nom === 'ROLE_MEDECIN') return
            this.salle_is_loading = true
            const data = {
                auth_id: this.user_id,
                page: this.p_goto_page,
                search_item: this.search_item
            }

            store_consultation.getConsultationsEnAttente(data).then((response) => {
                this.consultations_attentes_constantes = response.data
                this.p_last_page = response.last_page
                this.nb_attente_constantes = this.consultations_attentes_constantes.length
                this.p_total_pages = response.last_page
                if (this.consultations_attentes_constantes.length > 0) {
                    this.salle_is_empty = false
                } else {
                    this.salle_is_empty = true
                }
                this.salle_is_loading = false
            })
        },

        /**
         * Rafraichir la salle d'attente
         * @returns 
         */
        refreshSuiteDeSoins() {
            if (this.activeRole.nom === 'ROLE_MEDECIN') return
            this.suite_is_loading = true

            const data = {
                auth_id: this.user_id,
                page: this.sut_goto_page,
                search_item: this.search_item
            }

            store_consultation.getSuitesSoins(data).then((response) => {
                this.liste_suites_soins = response.data
                this.sut_last_page = response.last_page
                this.sut_total_pages = response.last_page
                if (this.liste_suites_soins.length > 0) {
                    this.suite_is_empty = false
                } else {
                    this.suite_is_empty = true
                }

                this.suite_is_loading = false
            })
        },

        selectSoin(soin, heure) {
            this.soin_selected = soin;
            this.heure_selected = heure
        },

        monthsOfYear: function() {

            var month = new Array()
            month = [{
                    "french": "Janvier",
                    "english": "January",
                    "nth_month": "1"
                },
                {
                    "french": "Février",
                    "english": "February",
                    "nth_month": "2"
                },
                {
                    "french": "Mars",
                    "english": "March",
                    "nth_month": "3"
                },
                {
                    "french": "Avril",
                    "english": "April",
                    "nth_month": "4"
                },
                {
                    "french": "Mai",
                    "english": "May",
                    "nth_month": "5"
                },
                {
                    "french": "Juin",
                    "english": "June",
                    "nth_month": "6"
                },
                {
                    "french": "Juillet",
                    "english": "July",
                    "nth_month": "7"
                },
                {
                    "french": "Aout",
                    "english": "August",
                    "nth_month": "8"
                },
                {
                    "french": "Septembre",
                    "english": "September",
                    "nth_month": "9"
                },
                {
                    "french": "Octobre",
                    "english": "October",
                    "nth_month": "10"
                },
                {
                    "french": "Novembre",
                    "english": "November",
                    "nth_month": "11"
                },
                {
                    "french": "Decembre",
                    "english": "December",
                    "nth_month": "12"
                },
            ]

            return month
        },
        /**
         * Show select options in dropdown
         * @param {int} j_state 
         * @param {string} selector 
         */
        async openSelectOption(j_state, selector) {
            this.curr_state = openSelectOptions.openSelectOption(j_state, selector)
        },

        /**
         * Select option in dropdown
         * @param {string} selected_value
         * @param {string} selected_id 
         * @param {string} selector 
         * @param {string} model_selector 
         */
        async selectOption(selected_value, selected_id, selector, model_selector) {
            this.curr_state = selectOption.chooseOption(selected_id, selector)

            switch (model_selector) {
                case 'jr':
                    this.jr_selected = selected_value;
                    break;
                case 'mm':
                    this.mm_selected = selected_value;
                    break;
                case 'cm':
                    this.consult_month_selected = selected_value;
                    this.monthConsultationsLoading = true
                    this.$store.dispatch('getCountMonthConsultations', { month: this.consult_month_selected.english }).then(
                        () => {
                            this.monthConsultationsLoading = false
                        }
                    )
            }
        },

        /**
         * Open Menu Dropdown
         */
        async openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        async closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        /**
         * Traiter une conduite
         * @param {*} t_cat 
         */
        treatCAT: function(t_cat, ccat) {
            this.selectedConduite = t_cat
            this.selectedMoment = ccat
        },

        /**
         * 
         * @param {*} route 
         */
        routeTo(route) {
            this.$router.push({ path: route })
        },

        previousPage() {
            if (this.p_curr_page > 1) {
                this.p_curr_page--;
                this.p_goto_page = this.p_curr_page
                this.refreshSalleAttente()
            }
        },

        nextPage() {
            if (this.p_curr_page < this.p_total_pages) {
                this.p_curr_page++;
                this.p_goto_page = this.p_curr_page
                this.refreshSalleAttente()
            }
        },

        gotoPage(page) {
            if (page !== this.p_curr_page) {
                this.p_curr_page = page;
                this.p_goto_page = this.p_curr_page
                this.refreshSalleAttente()
            }
        },

        sutPreviousPage() {
            if (this.sut_curr_page > 1) {
                this.sut_curr_page--;
                this.sut_goto_page = this.sut_curr_page
                this.refreshSuiteDeSoins()
            }
        },

        sutNextPage() {
            if (this.sut_curr_page < this.sut_total_pages) {
                this.sut_curr_page++;
                this.sut_goto_page = this.sut_curr_page
                this.refreshSuiteDeSoins()
            }
        },

        sutGotoPage(page) {
            if (page !== this.sut_curr_page) {
                this.sut_curr_page = page;
                this.sut_goto_page = this.sut_curr_page
                this.refreshSuiteDeSoins()
            }
        },

        searchPatient() {
            this.search_item = this.sut_filter

            this.refreshSuiteDeSoins()
        },

        searchPatientInSalle() {
            this.search_item = this.p_filter
            this.refreshSalleAttente()
        }
    }
}
